import React, { useState, useEffect } from 'react';
import './Navbar.css'
import { Link, useLocation } from 'react-router-dom';
import { Search, Phone, Menu, X, ChevronDown } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavbarSearch from './NavbarSearch/NavbarSearch';
import ContactButton from './contact-button';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState('/');
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Only track scroll on desktop and homepage
      if (isHomePage && window.innerWidth >= 992) {
        setIsScrolled(window.scrollY > 50);
      }
    };
  
    if (isHomePage && window.innerWidth >= 992) {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
        setIsScrolled(false);
      };
    } else {
      setIsScrolled(true); // Always show background on mobile/tablet or non-home pages
    }
  }, [isHomePage]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
  };

  const handleMobileNavClick = (path) => {
    setCurrentPath(path);
    toggleMobileMenu();
  };

  const productCategories = [
    {
      name: 'Paper Bags',
      path: '/paper-bags',
      subCategories: [
        { name: 'White Paper Bags', path: '/white-paper-bags' },
        { name: 'Brown Paper Bags', path: '/brown-paper-bags' },
        { name: 'SOS', path: '/SOS' },
        { name: 'Take Away bags', path: '/take-away-bags' },
        { name: 'Promotional Bags', path: '/promotional-bags' },
        // { name: 'Wrappers', path: '/wrappers' }
      ]
    },
    {
      name: 'Courier Bags',
      path: '/courier-bags',
      subCategories: [
        { name: 'POD Courier Bags', path: '/pod-courier-bags' },
        { name: 'Non Pod Courier Bags', path: '/non-pod-courier-bags' }
      ]
    },
    {
      name: 'Packaging Products',
      path: '/packaging-products',
      subCategories: [
        { name: 'Ld Shrink', path: '/ld-shrink-film' },
        { name: 'Liners', path: '/liners' },
        { name: 'Packaging Films', path: '/packaging-films' }
      ]
    }
  ];

  return (
    <>
      {!isHomePage && <div className="navbar-spacer d-none d-lg-block"></div>}
      {!isHomePage && <div className="navbar-spacer-mobile d-block d-lg-none"></div>}
      
      <div className={`fixed-top ${isScrolled ? 'scrolled' : ''} ${!isHomePage ? 'not-home' : ''}`}>
        {/* {(isScrolled || !isHomePage) && (
          <div className="bg-light py-2 d-none d-lg-block">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div className="d-flex gap-3">
                    <a href="#" className="text-secondary">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" className="text-secondary">
                      <i className="fab fa-twitter"></i>
                    </a>
                  
                    <a href="#" className="text-secondary">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <div className="col-md-4 text-center">
                  <span className="text-secondary abhaya-font">
                   sales@klmpack.com
                  </span>
                </div>
               
              </div>
            </div>
          </div>
        )} */}

        <nav className="navbar navbar-expand-lg navbar-light py-3">
          <div className="container">
            <div className="d-flex align-items-center">
              <Link className="navbar-brand d-flex align-items-center" to="/">
                <div className="logo-wrapper-klm">
                  <img 
                    src="/assets/icons/klm-icon.png" 
                    alt="KLM icon" 
                    className="navbar-logo"
                  />
                </div>
                <div className="ms-3 d-flex flex-column">
                  <h1 className="mb-0 company-name">
                    KLM Packaging Industries
                  </h1>
                  <small className="text-muted" style={{ fontSize: '0.85rem', fontStyle: 'italic',textAlign:'end' }}>
                    Carry Green, Choose Paper
                  </small>
                </div>
              </Link>
            </div>

            <div className="d-none d-lg-flex align-items-center justify-content-between flex-grow-1">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 Cormorant-Garamond fs-5">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${currentPath === '/' ? 'active' : ''}`} 
                    to="/"
                    onClick={() => setCurrentPath('/')}
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className={`nav-link ${currentPath === '/about' ? 'active' : ''}`} 
                    to="/about"
                    onClick={() => setCurrentPath('/about')}
                  >
                    About
                  </Link>
                </li>
                
                <li className="nav-item dropdown"
                    onMouseEnter={() => setIsProductsOpen(true)}
                    onMouseLeave={() => setIsProductsOpen(false)}
                >
                  <Link 
                    to="/products"
                    className={`nav-link ${currentPath === '/products' ? 'active' : ''}`}
                    onClick={() => setCurrentPath('/products')}
                    style={{ cursor: 'pointer' }}
                  >
                    Products
                  </Link>
                  <div 
                    className={`dropdown-menu ${isProductsOpen ? 'show' : ''}`}
                    style={{
                      display: isProductsOpen ? 'block' : 'none',
                      marginTop: '0',
                      borderTop: '2px solid #dc3545',
                      borderRadius: '0 0 8px 8px',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                      animation: 'fadeIn 0.3s ease',
                      minWidth: '250px'
                    }}
                  >
                    {productCategories.map((category) => (
                      <div 
                        key={category.path}
                        className="dropdown-item py-2 position-relative"
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
                          e.target.style.color = '#dc3545';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                          e.target.style.color = '#6c757d';
                        }}
                      >
                        <Link 
                          to={category.path}
                          className="d-block text-decoration-none"
                          style={{ color: 'inherit' }}
                          onClick={() => {
                            setCurrentPath(category.path);
                            setIsProductsOpen(false);
                          }}
                        >
                          {category.name}
                        </Link>
                        <div className="dropdown-menu position-absolute top-0 start-100 ms-1"
                          style={{
                            display: 'none',
                            borderLeft: '2px solid #dc3545',
                            borderRadius: '0 8px 8px 0',
                            boxShadow: '4px 4px 6px rgba(0,0,0,0.1)'
                          }}
                        >
                          {category.subCategories.map((subItem) => (
                            <Link 
                              key={subItem.path}
                              to={subItem.path}
                              className="dropdown-item py-2"
                              onClick={() => {
                                setCurrentPath(subItem.path);
                                setIsProductsOpen(false);
                              }}
                              style={{
                                color: '#6c757d',
                                transition: 'all 0.3s ease'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
                                e.target.style.color = '#dc3545';
                                e.target.style.paddingLeft = '1.5rem';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = '#6c757d';
                                e.target.style.paddingLeft = '1rem';
                              }}
                            >
                              {subItem.name}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </li>
                
                <li className="nav-item">
                  <Link 
                    className={`nav-link ${currentPath === '/contact' ? 'active' : ''}`} 
                    to="/contact"
                    onClick={() => setCurrentPath('/contact')}
                  >
                    Contact
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className={`nav-link ${currentPath === '/blogs' ? 'active' : ''}`} 
                    to="/blogs"
                    onClick={() => setCurrentPath('/blogs')}
                  >
                    Blogs
                  </Link>
                </li>
              </ul>

              <div className="d-flex align-items-center gap-4">
                {/* <button className="btn btn-link text-secondary p-0">
                  <Search size={20} />
                </button> */}
  <NavbarSearch />
  {/* <button className="btn btn-danger text-white px-4 py-2 d-flex align-items-center gap-2">
                  <Phone size={20} />
                  <span className="fw-medium">92 888 888 0000</span>
                </button> */}

<ContactButton 
            type="phone"
            variant="danger"
            text="+91 90634 27464" 
            className="text-white px-4 py-2"
          />
              </div>
            </div>

            <div className="d-lg-none d-flex align-items-center gap-3">
              {/* <button className="btn btn-link text-secondary p-0">
                <Search size={20} />
              </button> */}

<NavbarSearch />

              <button 
                className="btn btn-link text-dark p-0" 
                onClick={toggleMobileMenu}
              >
                {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </nav>
      </div>

      {/* Mobile Menu Overlay */}
      <div 
        className={`position-fixed top-0 start-0 w-100 h-100 bg-white ${isMobileMenuOpen ? 'd-block' : 'd-none'}`}
        style={{ zIndex: 1060 }}
      >
        <div className="container h-100 d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center py-3">
            <Link className="navbar-brand" to="/">
              <img 
                src="/assets/klm icon.jpg" 
                alt="KLM icon" 
                height="40"
                width="40"
              />
            </Link>
            <button 
              className="btn btn-link text-dark p-0" 
              onClick={toggleMobileMenu}
            >
              <X size={24} />
            </button>
          </div>
          
          <div className="flex-grow-1 d-flex flex-column justify-content-center">
            {/* Mobile Menu Items */}
             {/* Mobile Menu Items */}
      <ul className="navbar-nav mx-auto mb-2 mb-lg-0 Cormorant-Garamond fs-5">
        <li className="nav-item">
          <Link
            className={`nav-link ${currentPath === '/' ? 'active' : ''}`} 
            to="/"
            onClick={() => handleMobileNavClick('/')}
          >
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link 
            className={`nav-link ${currentPath === '/about' ? 'active' : ''}`} 
            to="/about"
            onClick={() => handleMobileNavClick('/about')}
          >
            About
          </Link>
        </li>
        <li className="nav-item dropdown">
    <div className="d-flex align-items-center justify-content-between">
        <Link 
            to="/products"
            className={`nav-link flex-grow-1 ${currentPath === '/products' ? 'active' : ''}`}
            onClick={() => handleMobileNavClick('/products')}
        >
            Products
        </Link>
        <button 
            className="btn btn-link p-0 px-2"
            onClick={(e) => {
                e.preventDefault();
                setIsProductsOpen(!isProductsOpen);
            }}
        >
            <ChevronDown 
                size={20}
                style={{ 
                    transition: 'transform 0.2s ease-in-out',
                    transform: isProductsOpen ? 'rotate(180deg)' : 'rotate(0)',
                    color: '#6c757d'
                }}
            />
        </button>
    </div>
    <div 
        className={`dropdown-menu ${isProductsOpen ? 'show' : ''}`}
        style={{
            display: isProductsOpen ? 'block' : 'none',
            marginTop: '0',
            borderTop: '2px solid #dc3545',
            borderRadius: '0 0 8px 8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            animation: 'fadeIn 0.3s ease'
        }}
    >
        {productCategories.map((category) => (
            <div key={category.path} className="dropdown-item">
                <div className="d-flex align-items-center justify-content-between py-2">
                    <Link 
                        to={category.path}
                        className="flex-grow-1"
                        onClick={() => handleMobileNavClick(category.path)}
                        style={{
                            color: '#6c757d',
                            textDecoration: 'none',
                            fontWeight: 'bold'
                        }}
                    >
                        {category.name}
                    </Link>
                    <button 
                        className="btn btn-link p-0 px-2"
                        onClick={(e) => {
                            e.preventDefault();
                            setExpandedCategory(
                                expandedCategory === category.path ? null : category.path
                            );
                        }}
                    >
                        <ChevronDown 
                            size={16}
                            style={{ 
                                transition: 'transform 0.2s ease-in-out',
                                transform: expandedCategory === category.path ? 'rotate(180deg)' : 'rotate(0)',
                                color: '#6c757d'
                            }}
                        />
                    </button>
                </div>
                <div 
                    className="ps-3"
                    style={{
                        display: expandedCategory === category.path ? 'block' : 'none',
                        animation: 'fadeIn 0.3s ease'
                    }}
                >
                    {category.subCategories.map((subItem) => (
                        <Link 
                            key={subItem.path}
                            to={subItem.path}
                            className="dropdown-item py-2"
                            onClick={() => {
                                handleMobileNavClick(subItem.path);
                                setExpandedCategory(null);
                                setIsProductsOpen(false);
                            }}
                            style={{
                                color: '#6c757d',
                                fontSize: '0.95em'
                            }}
                        >
                            {subItem.name}
                        </Link>
                    ))}
                </div>
            </div>
        ))}
    </div>
</li>
        <li className="nav-item">
          <Link 
            className={`nav-link ${currentPath === '/contact' ? 'active' : ''}`} 
            to="/contact"
            onClick={() => handleMobileNavClick('/contact')}
          >
            Contact
          </Link>
        </li>
        <li className="nav-item">
          <Link 
            className={`nav-link ${currentPath === '/blogs' ? 'active' : ''}`} 
            to="/blogs"
            onClick={() => handleMobileNavClick('/blogs')}
          >
            Blogs
          </Link>
        </li>
      </ul>


            <div className="text-center mt-4">
              {/* <button className="btn btn-warning text-white px-4 py-2 d-inline-flex align-items-center gap-2">
                <Phone size={20} />
                <span className="fw-medium">92 888 888 0000</span>
              </button> */}

               <ContactButton 
                type="phone"
                variant="danger"
                text="90634 27464" 
                className="text-white px-4 py-2 d-inline-flex align-items-center"
                isMobile={false}
              />
            </div>

            <div className="d-flex justify-content-center gap-4 mt-4">
              <a href="#" className="text-secondary fs-4">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="text-secondary fs-4">
                <i className="fab fa-twitter"></i>
              </a>
              {/* <a href="#" className="text-secondary fs-4">
                <i className="fab fa-pinterest"></i>
              </a> */}
              <a href="#" className="text-secondary fs-4">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="text-center py-4">
            {/* <div className="text-secondary mb-2 abhaya-font">digitalklmpackaging@gmail.com</div> */}
            {/* <div className="text-secondary">Mon - Sat 8:00 - 6:30, Sunday - CLOSED</div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;